<template>
	<div v-if="$screen.width <= 992" class="animated fadeIn pr-1 pl-1">
		<div class="container-mobile">
			<div class="my-expense-mobile">
				<div v-if="poLists.length > 0" class="my-expense-status-actions p-1">
					<div class="check-actions cursor-pointer" @click="switchCheckAll">
						<div class="d-flex text-left" v-if="isAllItemSelected(poLists)">
							{{ FormMSG(2, 'None') }}&nbsp;
							<component :is="getLucideIcon('Square')" :size="16" />
						</div>
						<div class="d-flex" v-else>
							{{ FormMSG(1, 'All') }} &nbsp;
							<component :is="getLucideIcon('CheckSquare')" :size="16" />
						</div>
					</div>
				</div>
				<div class="content pb-3" v-if="poLists.length > 0">
					<div
						class="card-expense"
						v-for="invoice in poLists"
						:key="invoice.id"
						:id="`${notSubmittedState && parseInt(invoice.validated, 10) === 0 ? 'card-expense-' + invoice.id : ''}`"
					>
						<div class="wrapper">
							<div class="resume">
								<div class="first-col">
									<b-form-checkbox
										v-if="+invoice.amountTotal !== 0"
										size="lg"
										v-model="invoice.selectState"
										@change="updateSelectedRows(invoice)"
									/>
								</div>
								<div class="second-col" :style="`width: ${notSubmittedState && parseInt(invoice.validated, 10) === 0 ? '56.5%;' : '67.5%;'}`">
									<div class="description">
										{{ invoice.description }}
									</div>
									<div class="title">#{{ invoice.id }}</div>
									<div>
										{{ FormMSG(5, 'Initial Amount') }} : <span class="amount">{{ invoice.amountTotal }}</span>
									</div>
									<div>
										{{ FormMSG(4, 'Remaining Amount') }} : <span class="amount">{{ invoice.amountTotal }}</span>
									</div>
									<div class="date">
										{{ dateToLiteral(invoice.date) }}
									</div>
									<!-- <div class="carbon" v-if="invoice.kgCoTwo">
										<div class="icon">
											<component :is="getLucideIcon('Sprout')" color="#47C7BF" :size="14" />
										</div>
										<div class="label">
											{{ invoice.kgCoTwo }}<span> CO<sub>2</sub></span>
										</div>
									</div>
									<div class="mileage-resume" v-else>
										<div class="details pt-1" v-if="invoice.fromLocation && invoice.toLocation">
											<div class="first-col">
												<div class="icon-rotate">
													<component :is="getLucideIcon('ArrowLeftRight')" color="#47C7BF" :size="16" />
												</div>
											</div>
											<div class="second-col">
												<div>{{ invoice.fromLocation }}</div>
												<div>{{ invoice.toLocation }}</div>
											</div>
										</div>
										<div class="details" :class="`${!invoice.km ? '' : 'pt-2'}`">
											<div class="first-col">
												<div class="icon">
													<component :is="getLucideIcon('Sprout')" color="#47C7BF" :size="!expense.km ? 14 : 16" />
												</div>
											</div>
											<div class="second-col" :class="`${!invoice.km ? 'spl-4' : ''}`">
												<div v-if="invoice.km">{{ invoice.km }} {{ distanceUnit }}</div>
												<div :style="`margin-bottom: ${invoice.km ? '0' : '-1px'}`">{{ invoice.kgCoTwo }} CO<sub>2</sub></div>
											</div>
										</div>
									</div> -->
								</div>
								<div class="third-col">
									<div class="status-wrapper">
										<div :class="`status ${invoice.statusClass}`">
											{{ invoice.validatedStatus }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="empty-data pb-3">
					{{ FormMSG(3, 'No Po found') }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import mapProps from '@/shared/vuePropsMapper';
import moment from 'moment';

export default {
	name: 'PoDrawDownDataMobile',
	mixins: [languageMessages, globalMixin],
	props: {
		poDataLists: Array,
		notSubmittedState: Boolean,
		allSelected: Boolean,
		selectedDataRows: Array,
		submittedState: Boolean,
		...mapProps(['forApprove', 'forDraft', 'forPending', 'forApproved'], {
			type: Boolean,
			default: false
		})
	},
	data() {
		return {
			checkAll: false,
			selectedRows: [],
			poLists: []
		};
	},
	methods: {
		switchCheckAll() {
			let payload = !this.isAllItemSelected(this.poLists);
			this.$emit('selectAll', payload);
		},
		updateSelectedRows(payload) {
			this.$emit('updateSelectedRows', payload.selectState, payload);
		},
		dateToLiteral(invoiceDate) {
			const langCurrent = this.currentLang;
			const fullLiteralDate = moment(invoiceDate).locale(`${langCurrent}`).format(`dddd, Do MMMM YYYY`);

			return fullLiteralDate;
		},
		isAllItemSelected(poItems) {
			return poItems.every(({ selectState }) => selectState);
		}
	},
	computed: {
		check() {
			return this.$store.getters.distanceUnit;
		}
	},
	watch: {
		poDataLists: {
			handler(newVal) {
				this.poLists = newVal;
			},
			immediate: true,
			deep: true
		},
		selectedDataRows: {
			handler(newVal) {
				this.selectedRows = newVal;
			},
			immediate: true,
			deep: true
		}
	}
};
</script>
